import { useSyncExternalStore } from 'react';

export const SESSION_CHANGED = 'stockflow:session-changed';
export function notifySessionChanged() { window.dispatchEvent(new Event(SESSION_CHANGED)); }
export function clearSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('role');
  localStorage.removeItem('selectedCompanyId');
  notifySessionChanged();
}
function subscribe(listener: () => void) {
  window.addEventListener(SESSION_CHANGED, listener);
  window.addEventListener('storage', listener);
  return () => {
    window.removeEventListener(SESSION_CHANGED, listener);
    window.removeEventListener('storage', listener);
  };
}
export function useSessionToken() {
  return useSyncExternalStore(subscribe, () => localStorage.getItem('token'), () => null);
}
